// extracted by mini-css-extract-plugin
export default {"attachInput":"AddAttachmentButton_attachInput__D-oy0"};